export let moreAppsLinkText = "WDYnvb";
export let openInNewTab = "Ub6gI";
export let openInNewWindow = "xVtusd";
export let unpinApp = "DC$pgb";
export let pinApp = "mGC6nd";
export let uninstallApp = "BgFa$c";
export default {moreAppsLinkText,openInNewTab,openInNewWindow,unpinApp,pinApp,uninstallApp};